/** If the given object has no keys, returns `null`. Otherwise returns the object. */
export function nullIfEmpty<T>(obj: T): T | null {
  return !obj || Object.keys(obj).length === 0 ? null : obj;
}
